module.exports = __webpack_public_path__ + "assets/GoodsRanking.59e92500.svg";